import styles from "./styles.module.css"
import { RiLoader4Line } from "react-icons/ri"

export default function Loading() {
    return (
        <div className={styles.loadingContainer}>
            <div className={styles.loading}><RiLoader4Line /></div>
        </div>
    );
}